import { WithStyles } from "@material-ui/core/styles";
import { Instrument } from "apis/models/commons/instrument";
import { Column } from "models/common";
import { styles } from "./styles";

export type RowMoreInfo = {
  displaySymbol: string;
  semanalPrice: number;
  monthlyPrice: number;
  annualPrice: number;
  enAnoPrice: number;
};

export type Card = {
  address: string;
  finalColumn: string;
  finalRow: number;
  initialColumn: string;
  initialRow: number;
  rowNumber: number;
  subscription: any;
  marketId?: number;
  rowMoreInfo?: RowMoreInfo[] | null;
  columnList: Column[];
  worksheetId: string;
  instruments: Instrument[];
  tableName: string;
  tableWithHeader:boolean
};

export interface AppProps extends WithStyles<typeof styles> {
  setShowSpinner: (showSpinner: boolean) => void;
  logOutUser: () => void;
  isDelay:boolean;
}

export interface AppState {
  copyBtn:Boolean;
  cardPaste:Boolean;
  cardTableEnabled:Boolean;
  errorRender: boolean;
  responsestate: string;
  dataTable: any;
  TableNameTitle: any;
  subscription: any;
  dataitem: string[];
  childData: null;
  dataSnackbar: {
    showSnackbar: boolean;
    severity: string;
    message: string;
    autoHideDuration: number;
  };
  dataAlert: {
    showAlert: boolean;
    type: string;
    title: string;
    message: string;
  };
  copyCard: {
    address: string;
    worksheetId: string;
    isCopy: boolean;
  };
  currentCard: {
    address: string;
    instruments: Instrument[];
    worksheetId: string;
    tableName: string;
    columnList: Column[];
  };

  activeCards: Card[];
  updateMarketTable: boolean;
  dataRealTimeParams: RealTimeParams[];
  addressItem: any;
  activeTab:any;
  downloadHistorySuccess:boolean;
}

export type TableParams = {
  headers: Column[];

  lsColumns: Array<string>;
  formatInstrumentForLS: Array<string>;
  formatInstrumentWithPositionFieldsForLS: Array<string>;
  rows: Array<any>;
  tableName: string;
  address: string;
  TableRow: React.ComponentClass<any>;
};

export type AddTableParams = {
  formatInstrumentForLS: Array<string>;
  formatInstrumentWithPositionFieldsForLS: Array<string>;
  rows: Array<any>;
  address: string;
  tableName: string;
  marketId: number;
  worksheetId: string;
  columnList: Column[];
  instruments: Instrument[];
};

export type RealTimeParams = {
  formatInstrumentForLS: Array<string>;
  formatInstrumentWithPositionFieldsForLS: Array<string>;
  rowNumber: number;
  startingColumnValue: string;
  finalColumnValue: string;
  activeCard: Card;
  worksheetId: string;
};

export type UpdateRowTableParams = {
  columnList: Column[];
  data: any;
  startingColumnValue: string;
  finalColumnValue: string;
  rowNumber: number;
  worksheetId: string;
};
export const initDataSnackbar = {
  showSnackbar: false,
  severity: "",
  message: "",
  autoHideDuration: 0,
};

export const initDataAlert = {
  showAlert: false,
  type: "",
  title: "",
  message: "",
};
